import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from '../services';
import KedvezmenyForm from './KedvezmenyForm';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import _ from 'lodash';
import Lib from '../../../commons/lib';
import moment from 'moment';
import RFForm from '../../../components/Form/RFForm';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';

class KedvezmenyContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      alanyFormStatus: 'DATA',

      // DATA
      baseJson: [],
      itemJson: [],
      viewObj: {},
      viewItemObj: {},
      expandedItems: [],
      currentId: undefined,
      currentItemId: undefined,
      torlesId: undefined,
      torlesItemId: undefined,

      // FORM VALUES
      formAzonosito: '',
      formNev: '',
      formKedvezmenyTipus: null,
      formFunkciok: [],
      formTipus: null,
      formErvenyesules: null,
      formMertekTipus: false,
      formMertek: '',
      formKezdete: null,
      formVege: null,
      formCiklusMennyiseg: '',
      formCiklusEgyseg: null,
      formKartyaTipusok: [],
      formAlanya: null,
      formAlanyai: [],

      //FORM VALUES ALANY
      formHelyszinek: [],

      // MODAL UTILS
      formTypeStatus: false,
      alanyFormTypeStatus: false,
      modalView: false,
      modalDelete: false,
      modalAlanyDelete: false,
      modalForm: false,
      modalAlanyForm: false,
      saveButtonLoading: false,
      saveAlanyButtonLoading: false,
      deleteButtonLoading: false,
      deleteAlanyButtonLoading: false,

      alanyJSON: new Map(),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.listKedvezmeny();
      }
    }
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleDeleteAlanyModal = () => {
    this.setState(prevState => ({ modalAlanyDelete: !prevState.modalAlanyDelete }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleAlanyFormModal = () => {
    this.setState(prevState => ({ modalAlanyForm: !prevState.modalAlanyForm }));
  }

  handleNewClick = () => {
    this.setState({
      currentId: null,
      formStatus: 'DATA',
      formTypeStatus: 'FEL',
      formAzonosito: '',
      formNev: '',
      formKedvezmenyTipus: null,
      formFunkciok: [],
      formTipus: null,
      formErvenyesules: null,
      formMertekTipus: false,
      formMertek: '',
      formKezdete: null,
      formVege: null,
      formCiklusMennyiseg: '',
      formCiklusEgyseg: null,
      formKartyaTipusok: [],
      formAlanya: null,
      formAlanyai: [],
    }, () => this.toggleFormModal());
  }

  handleEditClick = (id) => {
    this.setState({
      formTypeStatus: 'MOD',
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getKedvezmenyForm(id);
      this.toggleFormModal();
    });
  }

  handleEditAlanyClick = (id, row) => {
    this.setState({
      alanyFormTypeStatus: 'MOD',
      alanyformStatus: 'LOAD',
      currentId: row.id,
      currentItemId: row.tetelid,
    }, () => {
      this.getKedvezmenyAlanyForm(this.state.currentId, this.state.currentItemId);
      this.toggleAlanyFormModal();
    });
  }

  handleViewClick = (id) => {
    this.setState({
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getKedvezmenyView(id, false);
      this.toggleViewModal();
    });
  }

  handleViewItemsClick = (id) => {
    
    if (!this.state.expandedItems.includes(id)) {
      Services.listKedvezmenyListAlanya(id, (err, res) => {
        if (!err) {
          let tempMap = this.state.alanyJSON;
          tempMap.set(id, res[0]);
          
          this.setState({ alanyJSON: tempMap });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });

      this.setState({
        expandedItems: [...this.state.expandedItems, id]
      });
    } else {
      this.setState(() => ({
        expandedItems: this.state.expandedItems.filter(x => x !== id)
      }));
    }
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleDeleteAlanyClick = (id, row) => {
    this.setState({
      torlesId: row.id,
      torlesItemId: row.tetelid,
    }, () => {
      this.toggleDeleteAlanyModal();
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : new Date(v);
    this.setState({
      [name]: value
    });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  emptyKedvezmenyAlanyai = () => {
    this.setState({ formAlanyai: [] });
  }

  toggleMertekTipus = () => {
    this.setState(prevState => ({ formMertekTipus: !prevState.formMertekTipus }));
  }

  getKedvezmenyForm = (id) => {
    this.setState({
      formStatus: 'LOAD',
    }, () => {
      Services.getKedvezmeny(id, (err, res) => {
        if (!err) {
          this.setState({
            formStatus: 'DATA',
            formAzonosito: res[0].azonosito,
            formNev: res[0].nev,
            formTipus: res[0].tipus,
            formKedvezmenyTipus: { id: res[0].kedvezmenyTipusId, nev: res[0].kedvezmenyTipusNev },
            formFunkciok: res[0].funkciok,
            formErvenyesules: res[0].ervenyesules,
            formMertekTipus: !!res[0].szazalek,
            formMertek: res[0].osszeg ? res[0].osszeg : res[0].szazalek,
            formKezdete: res[0].kezdete,
            formVege: res[0].vege,
            formCiklusMennyiseg: res[0].ciklusMennyiseg,
            formCiklusEgyseg: res[0].ciklusEgyseg,
            formKartyaTipusok: res[0].kartyatipusok,
            formAlanya: res[0].alanya,
            formAlanyai: res[0].alanyok,
          });
        } else {
          this.setState({
            formStatus: 'NETW'
          });
        }
      });
    });
  }

  getKedvezmenyAlanyForm = (kedvezmenyId, alanyId) => {
    this.setState({
      alanyFormStatus: 'LOAD',
    }, () => {
      Services.getKedvezmenyAlany(kedvezmenyId, alanyId, (err, res) => {
        if (!err) {
          this.setState({
            alanyFormStatus: 'DATA',
            formHelyszinek: res[0].helyszinek
          });
        } else {
          this.setState({
            alanyFormStatus: 'NETW'
          });
        }
      });
    });
  }

  saveKedvezmenyAlany = () => {
    const {
      currentId,
      currentItemId,
      formHelyszinek,
      alanyFormTypeStatus
    } = this.state;

    this.setState({
      saveAlanyButtonLoading: true
    }, () => {
      if (alanyFormTypeStatus == 'FEL') {
        let submitObj = {};

        submitObj.kedvezmenyId = currentId;
        submitObj.alanyaId = currentItemId;
        submitObj.helyszinIds = formHelyszinek.map(h => h.id);

        Services.addKedvezmenyAlany(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Személy felvéve!');
            this.toggleAlanyFormModal();
            this.listKedvezmeny();
            this.setState({
              saveAlanyButtonLoading: false
            });
          } else {
            this.setState({
              saveAlanyButtonLoading: false
            });
          }
        });
      } else if (alanyFormTypeStatus == 'MOD') {
        let submitObj = {};

        submitObj.kedvezmenyId = currentId;
        submitObj.alanyaId = currentItemId;
        submitObj.helyszinIds = formHelyszinek.map(h => h.id);

        Services.editKedvezmenyAlany(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Személy módosítva!');
            this.toggleAlanyFormModal();
            this.listKedvezmeny();
            this.setState({
              saveAlanyButtonLoading: false
            });
          } else {
            this.setState({
              saveAlanyButtonLoading: false
            });
          }
        });
      }
    });
  }

  saveKedvezmeny = (formValues) => {
    const {
      currentId,
      formAzonosito,
      formErvenyesules,
      formCiklusMennyiseg,
      formTypeStatus,
      formKedvezmenyTipus,
      formFunkciok,
      formTipus,
      formNev,
      formMertekTipus,
      formKezdete,
      formVege,
      formMertek,
      formCiklusEgyseg,
      formKartyaTipusok,
      formAlanya,
      formAlanyai,
    } = this.state;

    this.setState({
      saveButtonLoading: true
    }, () => {
      if (formTypeStatus == 'FEL') {
        let submitObj = {};

        submitObj.azonosito = formAzonosito;
        submitObj.nev = formNev;
        submitObj.kedvezmenyTipusId = formKedvezmenyTipus && formKedvezmenyTipus.id;
        submitObj.funkcioIds = formFunkciok.map(x => x.id);
        submitObj.tipus = formTipus && formTipus.name;
        submitObj.ervenyesules = formErvenyesules;
        submitObj.osszeg = !formMertekTipus ? formMertek : null;
        submitObj.szazalek = formMertekTipus ? formMertek : null;
        submitObj.kezdete = formKezdete ? TimeFormatter.formatIso(formKezdete) : null;
        submitObj.vege = formVege ? TimeFormatter.formatIso(formVege) : null;
        submitObj.ciklusMennyiseg = formCiklusMennyiseg;
        submitObj.ciklusEgyseg = formCiklusEgyseg && formCiklusEgyseg.name;
        submitObj.kartyaTipusIds = formKartyaTipusok.map(x => x.id);
        submitObj.alanya = formAlanya && formAlanya.name;
        submitObj.alanyaIds = formAlanyai && formAlanyai.map(a => a.id);

        Services.addKedvezmeny(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Kedvezmény felvéve!');
            this.toggleFormModal();
            this.listKedvezmeny();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      } else if (formTypeStatus == 'MOD') {
        let submitObj = {};

        submitObj.id = currentId;
        submitObj.azonosito = formAzonosito;
        submitObj.nev = formNev;
        submitObj.kedvezmenyTipusId = formKedvezmenyTipus && formKedvezmenyTipus.id;
        submitObj.funkcioIds = formFunkciok.map(x => x.id);
        submitObj.tipus = formTipus && formTipus.name;
        submitObj.ervenyesules = formErvenyesules;
        submitObj.osszeg = !formMertekTipus ? formMertek : null;
        submitObj.szazalek = formMertekTipus ? formMertek : null;
        submitObj.kezdete = formKezdete ? TimeFormatter.formatIso(formKezdete) : null;
        submitObj.vege = formVege ? TimeFormatter.formatIso(formVege) : null;
        submitObj.ciklusMennyiseg = formCiklusMennyiseg;
        submitObj.ciklusEgyseg = formCiklusEgyseg && formCiklusEgyseg.name;
        submitObj.kartyaTipusIds = formKartyaTipusok.map(x => x.id);
        submitObj.alanya = formAlanya && formAlanya.name;
        submitObj.alanyaIds = formAlanyai && formAlanyai.map(a => a.id);

        Services.editKedvezmeny(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Kedvezmény módosítva!');
            this.toggleFormModal();
            this.listKedvezmeny();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }

  listKedvezmeny = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listKedvezmeny((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
            expandedItems: [],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getKedvezmenyView = (id) => {
    this.setState({
      viewStatus: 'LOAD',
    }, () => {
      Services.getKedvezmeny(id, (err, res) => {
        if (!err) {
          this.setState({
            viewObj: res[0],
            viewStatus: 'DATA',
          });
        } else {
          this.setState({
            viewStatus: 'NETW'
          });
        }
      });
    });
  }

  deleteKedvezmeny = () => {
    this.setState({
      deleteButtonLoading: true
    }, () => {
      Services.deleteKedvezmeny(this.state.torlesId, (err) => {
        if (!err) {
          this.toggleDeleteModal();
          this.listKedvezmeny();
          this.props.globals.addSuccess('Kedvezmény törölve!');
          this.setState({
            deleteButtonLoading: false,
            currentId: null
          });
        } else {
          this.setState({
            deleteButtonLoading: false
          });
        }
      });
    });
  }

  deleteKedvezmenyAlany = () => {
    this.setState({
      deleteAlanyButtonLoading: true
    }, () => {
      Services.deleteKedvezmenyAlany(this.state.torlesId, this.state.torlesItemId, (err) => {
        if (!err) {
          this.toggleDeleteAlanyModal();
          this.listKedvezmeny();
          this.props.globals.addSuccess('Tétel törölve!');
          this.setState({
            deleteAlanyButtonLoading: false
          });
        } else {
          this.setState({
            deleteAlanyButtonLoading: false
          });
        }
      });
    });
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>
        </React.Fragment>
        {this.props.globals.hasRole(['KEDVEZMENY_KEDVEZMENY'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
            {row.vanalany > 0 &&
              <React.Fragment>
                <Button className="icon-list table-action-icon" id={'action-view-' + cell + '-alanyok'} onClick={() => this.handleViewItemsClick(cell)} onMouseDown={(e) => { if (e) e.preventDefault(); }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-alanyok'} delay={50}>
                  {row.alanya.caption}
                </UncontrolledTooltip>
              </React.Fragment>
            }
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  jegyTableIconFormatter = (cell, row) => {
    return (
      <div>
        {this.props.globals.hasRole(['KEDVEZMENY_KEDVEZMENY'], true) && (
          <React.Fragment>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + '-alany-delete'} onClick={() => this.handleDeleteAlanyClick(cell, row)} onMouseDown={(e) => { if (e) e.preventDefault() }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-alany-delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  szemelyTableIconFormatter = (cell, row) => {
    return (
      <div>
        {this.props.globals.hasRole(['KEDVEZMENY_KEDVEZMENY'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + '-alany-modositas'} onClick={() => this.handleEditAlanyClick(cell, row)} onMouseDown={(e) => { if (e) e.preventDefault() }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-alany-modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + '-alany-delete'} onClick={() => this.handleDeleteAlanyClick(cell, row)} onMouseDown={(e) => { if (e) e.preventDefault() }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-alany-delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    return (
      <div>
        <h6>Kedvezmény:</h6>
        <b>Azonosító: </b>
        {viewObj && viewObj.azonosito}
        <br />
        <b>Név: </b>
        {viewObj && viewObj.nev}
        <br />
        <b>Kedvezmény típus: </b>
        {viewObj && viewObj.kedvezmenyTipusNev}
        <br />
        <b>Felhasználási korlát: </b>
        {viewObj && viewObj.ervenyesules || "KORLÁTLAN"}
        <br />
        <b>Beválthatóság: </b>
        {viewObj && viewObj.tipus && viewObj.tipus.caption}
        <br />
        <b>Kedvezmény mértéke: </b>
        {viewObj && viewObj.mertek}
        <br />
        <b>Érvényesség kezdete: </b>
        {viewObj && viewObj.kezdete && TimeFormatter.formatDateTime(viewObj.kezdete)}
        <br />
        <b>Érvényesség vége: </b>
        {viewObj && viewObj.vege && TimeFormatter.formatDateTime(viewObj.vege)}
        <br />
        <b>Ciklus: </b>
        {viewObj && (viewObj.ciklusMennyiseg && viewObj.ciklusEgyseg) ? (viewObj.ciklusMennyiseg + " " + viewObj.ciklusEgyseg.caption) : ""}
        <br />
        {/* <b>Kedvezmény kód: </b>
        {viewObj && viewObj.kedvezmenyKod} 
        <br /> */}
        <b>Vásárlói kártyatípusok: </b>
        {viewObj && viewObj.kartyaTipusNevek}
        <br />
        <b>Kedvezményre jogosult: </b>
        {viewObj && viewObj.alanya && (viewObj.alanya.caption + ": " + viewObj.alanyok.map(x => x.nev).join(', '))}
      </div>
    );
  }

  dateColumnFormatter = (cell) => {
    let date = cell.split('|');
    return (
      <React.Fragment>
        <div style={{ whiteSpace: 'normal' }}>
          {date[0]}
        </div>
        <div style={{ whiteSpace: 'normal' }}>
          {date[1]}
        </div>
      </React.Fragment>
    )
  }

  kapcsolodoFormatter = (cell) => {
    return cell ? 'Igen' : 'Nem';
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'azonosito',
        text: 'Kedvezmény azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Kedvezmény neve',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'mertek',
        text: 'Kedvezmény mértéke',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'kartyahozkapcsolodo',
        text: 'Kártyához kapcsolódó',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: this.kapcsolodoFormatter,
      },
      {
        dataField: 'ervenyessegperiod',
        text: 'Érvényesség',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: this.dateColumnFormatter,
        filterValue: (cell) => {
          let date = cell.split('|');
          return date[0] + (date[1] ? ' ' + date[1] : '');
        }
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    const setColumns = (kedvezmeny) => {
      switch (kedvezmeny.alanya.name) {
        case "JEGY":
          return [
            {
              dataField: 'nev',
              text: 'Név',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                whiteSpace: 'pre-line'
              },
              sort: true
            },
            {
              dataField: 'tetelid',
              text: 'Műveletek',
              formatter: this.jegyTableIconFormatter
            }
          ];
        case "SZEMELY":
          return [
            {
              dataField: 'nev',
              text: 'Név',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                whiteSpace: 'pre-line'
              },
              sort: true
            },
            {
              dataField: 'helyszinek',
              text: 'Helyszínek',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                whiteSpace: 'pre-line'
              },
              sort: true,
            },
            {
              dataField: 'tetelid',
              text: 'Műveletek',
              formatter: this.szemelyTableIconFormatter
            }
          ];
      }
    }

    const expandRow = {
      renderer: (row) => {
        return <React.Fragment>
          <h5>{row.alanya.caption + ": "}</h5>
          <BootstrapTable
            bootstrap4
            keyField="tetelid"
            data={this.state.alanyJSON.has(row.id) ? this.state.alanyJSON.get(row.id) : []}
            columns={setColumns(row)}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </React.Fragment>
      },
      expanded: this.state.expandedItems,
      expandByColumnOnly: true,
    };

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          expandRow={expandRow}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderTableView = () => {
    return (
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listKedvezmeny()}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderAlanyForm = () => {
    const loadHelyszinOptions = (input, callback) => {
      Services.listHelyszinSelect((err, res) => {
        if (!err) {
          let options = [];
          res[0].filter(h => h.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
            options.push(item);
          });
          callback(options);
        }
      });
    }

    return (
      <div className="col-md-12" style={{ paddingRight: '2px' }}>
        <SelectField
          variant='async'
          label='Helyszínek:'
          name="formHelyszinek"
          id="formHelyszinek"
          placeholder="Kezdj el gépelni..."
          noOptionsMessage={() => 'Nincs keresési eredmény'}
          onChange={v => this.handleSelectInputChange(v, 'formHelyszinek')}
          loadOptions={_.debounce(loadHelyszinOptions, 1000)}
          getOptionLabel={option => option.nev}
          getOptionValue={option => option.id}
          value={this.state.formHelyszinek}
          isMulti
          isClearable
          defaultOptions
        />
      </div>
    );
  }

  renderModals = () => {
    const kedvezmeny = JSON.parse(JSON.stringify(this.state.baseJson)).find(k => k.id === this.state.currentId);
    return (
      <React.Fragment>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteKedvezmeny()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalAlanyDelete} toggle={this.toggleDeleteAlanyModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteKedvezmenyAlany()}
              loading={this.state.deleteAlanyButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteAlanyModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static">
          <ModalHeader>
            {'Megtekintés'}
          </ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getKedvezmenyView(this.state.currentId)}
              />),
              DATA: (this.renderView())
            }[this.state.viewStatus]}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
          </ModalFooter>
        </Modal>

        {this.state.currentId &&
          <Modal isOpen={this.state.modalAlanyForm} toggle={this.toggleAlanyFormModal} backdrop="static">
            <RFForm
              modal
              onSubmit={this.saveKedvezmenyAlany}
              title={this.state.alanyFormTypeStatus == 'FEL' ? kedvezmeny.alanya.caption + ' rögzítése' : kedvezmeny.alanya.caption + ' módosítása'}
              footer={
                <>
                  <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    loading={this.state.saveAlanyButtonLoading}
                  >
                    {'Mentés'}
                  </ProgressButton>
                  <Button type="button" color="secondary" onClick={this.toggleAlanyFormModal}>Mégsem</Button>
                </>
              }
            >
              {{
                LOAD: (<Loader />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => this.getKedvezmenyAlanyForm(this.state.currentId, this.state.currentItemId)}
                />),
                DATA: (this.renderAlanyForm())
              }[this.state.alanyFormStatus]}
            </RFForm>
          </Modal>
        }

        <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg">
          <RFForm
            modal
            onSubmit={this.saveKedvezmeny}
            title={this.state.formTypeStatus == 'FEL' ? 'Kedvezmény rögzítése' : 'Kedvezmény módosítása'}
            footer={
              <>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={this.state.saveButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleFormModal}>Mégsem</Button>
              </>
            }
          >
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => this.getKedvezmenyForm(this.state.currentId)}
                />),
              DATA:
                <KedvezmenyForm
                  modositas={!!this.state.currentId}
                  formAzonosito={this.state.formAzonosito}
                  formNev={this.state.formNev}
                  formKedvezmenyTipus={this.state.formKedvezmenyTipus}
                  formFunkciok={this.state.formFunkciok}
                  formTipus={this.state.formTipus}
                  formErvenyesules={this.state.formErvenyesules}
                  formMertekTipus={this.state.formMertekTipus}
                  formMertek={this.state.formMertek}
                  formKezdete={this.state.formKezdete}
                  formVege={this.state.formVege}
                  formCiklusEgyseg={this.state.formCiklusEgyseg}
                  formCiklusMennyiseg={this.state.formCiklusMennyiseg}
                  formKartyaTipusok={this.state.formKartyaTipusok}
                  formAlanya={this.state.formAlanya}
                  formAlanyai={this.state.formAlanyai}
                  toggleMertekTipus={this.toggleMertekTipus}
                  handleInputChange={this.handleInputChange}
                  handleSelectInputChange={this.handleSelectInputChange}
                  handleDateInputChange={this.handleDateInputChange}
                  emptyKedvezmenyAlanyai={this.emptyKedvezmenyAlanyai}
                />
            }[this.state.formStatus]}
          </RFForm>
        </Modal>
      </React.Fragment>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row" style={{ marginTop: 22 }}>
          <div className="col-md-12">
            {this.props.globals.hasRole(['KEDVEZMENY_KEDVEZMENY'], true) && (
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                {'Új kedvezmény'}
              </Button>
            )}
          </div>
          {this.renderTableView()}
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

KedvezmenyContent.propTypes = {
  globals: PropTypes.object
};

export default KedvezmenyContent;
